"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Unlock = function Unlock(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 10.5H8C7.86739 10.5 7.74021 10.5527 7.64645 10.6464C7.55268 10.7402 7.5 10.8674 7.5 11V17C7.5 17.1326 7.55268 17.2598 7.64645 17.3536C7.74021 17.4473 7.86739 17.5 8 17.5H16C16.1326 17.5 16.2598 17.4473 16.3536 17.3536C16.4473 17.2598 16.5 17.1326 16.5 17V11C16.5 10.8674 16.4473 10.7402 16.3536 10.6464C16.2598 10.5527 16.1326 10.5 16 10.5ZM12.5 13.8659V15C12.5 15.1326 12.4473 15.2598 12.3536 15.3536C12.2598 15.4473 12.1326 15.5 12 15.5C11.8674 15.5 11.7402 15.4473 11.6464 15.3536C11.5527 15.2598 11.5 15.1326 11.5 15V13.8659C11.3094 13.7558 11.1604 13.5859 11.0761 13.3825C10.9919 13.1792 10.9771 12.9537 11.0341 12.741C11.091 12.5284 11.2166 12.3405 11.3912 12.2065C11.5659 12.0725 11.7799 11.9999 12 11.9999C12.2201 11.9999 12.4341 12.0725 12.6088 12.2065C12.7834 12.3405 12.909 12.5284 12.9659 12.741C13.0229 12.9537 13.0081 13.1792 12.9239 13.3825C12.8396 13.5859 12.6906 13.7558 12.5 13.8659Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 4.5C11.3372 4.50074 10.7017 4.76436 10.233 5.23304C9.76436 5.70173 9.50074 6.33718 9.5 7V9H10.5V7C10.5 6.60218 10.658 6.22064 10.9393 5.93934C11.2206 5.65804 11.6022 5.5 12 5.5C12.3978 5.5 12.7794 5.65804 13.0607 5.93934C13.342 6.22064 13.5 6.60218 13.5 7V9H14.5V7C14.4993 6.33718 14.2356 5.70173 13.767 5.23304C13.2983 4.76436 12.6628 4.50074 12 4.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M10.5 9H9.5V10.5H10.5V9Z",
    fill: props.foregroundColor
  }));
};

Unlock.defaultProps = {
  altText: "Unlock",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Unlock.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Unlock;
exports.default = _default;